var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-help-view',{attrs:{"query":require('@/graphql/queries/user-help/UserHelpArticle.gql'),"variables":{ id: _vm.id },"back":_vm.back,"data-key":"userHelpArticle"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('div',{staticClass:"user-help-article-content",domProps:{"innerHTML":_vm._s(data.content)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }